import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
});

export const fetchCategories = () => api.get("/categories").then((r) => r.data.categories);

export const fetchBrands = (categorySlug) =>
  api.get(`/categories/${categorySlug}/brands`).then((r) => r.data.brands);

export const fetchModelFamilies = (categorySlug, brandSlug, search = "") =>
  api
    .get(`/categories/${categorySlug}/brands/${brandSlug}/models`, {
      params: search ? { search } : {},
    })
    .then((r) => r.data.families);

export const requestQuote = (payload) => api.post("/quote", payload).then((r) => r.data);

export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);

export const searchModels = (q) => api.get("/search", { params: { q } }).then((r) => r.data);

export { API_BASE };
